<template>
    <div class="form-input">
        <label class="checkbox" :class="{disabled, error}">
            <input
                type="checkbox"
                :name="name"
                :id="id"
                :disabled="disabled"

                :checked="isChecked"
                :value="value"
                @change="updateInput"
            >

            <div class="box elevate">
                <div class="icon-ic-tick"></div>
            </div>

            <div class="text">
                <slot></slot>
            </div>
        </label>

        <transition name="smooth">
            <div
                class="feedback color-red f-small"
                v-if="error"
            >
                <div class="mt-1">{{error}}</div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    model: {
        prop: 'modelValue',
        event: 'change'
    },

    props: {
        value:      { type: String },
        modelValue: { default: "" },
        trueValue:  { default: true },
        falseValue: { default: false },
        error:      { type: String },
        disabled:   { type: Boolean },
        name:       { type: String },
        id:         { type: String }
    },

     computed: {
        isChecked() {
            if (this.modelValue instanceof Array) {
                return this.modelValue.includes(this.value)
            }
            // Note that `true-value` and `false-value` are camelCase in the JS
            return this.modelValue === this.trueValue
        }
    },

    methods: {
        presskey ($event) {
            if ($event.keyCode === 13) $event.target.click();
        },


        updateInput(event) {
            let isChecked = event.target.checked;

            if (this.modelValue instanceof Array) {
                let newValue = [...this.modelValue]
                if (isChecked) {
                    newValue.push(this.value)
                } else {
                    newValue.splice(newValue.indexOf(this.value), 1)
                }
                this.$emit('change', newValue)
            } else {
                this.$emit('change', isChecked ? this.trueValue : this.falseValue)
            }
        }
    }
}
</script>
